export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const PARTNER_ACCOUNT_ID_STORAGE_KEY = "loginPartnerAccountId";
export const IS_SIDEBAR_COLLAPSED = "shell:is-sidebar-collapsed";

export const CONTACTS_V2_LOCAL_STORAGE_KEYS = [
  "contactsV2_contacts_columns_1",
  "contactsV2_contacts_rows_1",
  "contactsV2_contacts_sort_1",
  "contactsV2_customFields_columns_1",
  "contactsV2_customFields_rows_1",
  "contactsV2_customFields_sort_1",
  "contactsV2_historyExport_columns_1",
  "contactsV2_historyExport_rows_1",
  "contactsV2_historyExport_sort_1",
  "contactsV2_historyImport_columns_1",
  "contactsV2_historyImport_rows_1",
  "contactsV2_historyImport_sort_1",
  "contactsV2_lists_columns_1",
  "contactsV2_lists_rows_1",
  "contactsV2_lists_sort_1",
  "contactsV2_segments_columns_1",
  "contactsV2_segments_rows_1",
  "contactsV2_segments_sort_1",
];

export const REPORTING_LOCAL_STORAGE_KEYS = [
  "showSendConfirm",
  "mfe-reports-user-preference",
];

export const MFE_LOGIN_LOCAL_STORAGE_KEYS = [
  "sinchid_redirect_notice_modal_last_time_showed",
  "mfa_modal_dismissed",
  "set_email_modal_dismissed",
];

export const CACHED_COUNTRY_KEY = "cachedCountryData";
